import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword, signInAnonymously } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCcR8JoVu1ClfxgRqgdIqGipVyFdZJnvcA",
    authDomain: "zinea-pa.firebaseapp.com",
    projectId: "zinea-pa",
    storageBucket: "zinea-pa.appspot.com",
    messagingSenderId: "1749123393",
    appId: "1:1749123393:web:960339b718257b0e3961c0",
    measurementId: "G-XZMH867VZC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Export authentication functions for use in admin components
export const signInAdmin = async (email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password);
        console.log('Admin authenticated successfully');
        return { success: true };
    } catch (error) {
        console.error('Failed to authenticate admin:', error);
        return { success: false, error: error.message };
    }
};

export const signOutAdmin = async () => {
    try {
        await auth.signOut();
        console.log('Admin signed out successfully');
        return { success: true };
    } catch (error) {
        console.error('Failed to sign out:', error);
        return { success: false, error: error.message };
    }
};

export default app;
